import React, { useState, useEffect } from 'react';
import { SessionTimerTypes } from './SessionTimerTypes';
import { secondsToPercentage as secondsToPercentageHandler } from './helper/TimerHelpers';
import { SessionTimeOutTimer } from './components/SessionTimeOutTimer';
import { differenceInSeconds } from 'date-fns/esm';
import { generalSessionTimerConstants } from './constants/generalConstants';

export const SessionTimer = ({
  sessionExpiryTime,
  bodyHeight,
  logOutHandler,
  contextObj,
  sessionExtendCallHandler,
}: SessionTimerTypes.TSessionTimerComponent) => {
  const currDate = new Date();
  const [totalDifferenceInSeconds, setTotalDifferenceInSeconds] = useState<
    number
  >(0);
  const [secondToPercentageArray, setSecondsToPercentageArray] = useState<
    number[]
  >([]);
  const { interval, sessionTimerHeading } = generalSessionTimerConstants;

  useEffect(() => {
    const expiryDate = new Date(sessionExpiryTime);
    const numOfSeconds = differenceInSeconds(expiryDate, currDate);
    const secondsToPercentageArr = secondsToPercentageHandler(numOfSeconds);
    setTotalDifferenceInSeconds(numOfSeconds);
    setSecondsToPercentageArray(secondsToPercentageArr);
  }, [sessionExpiryTime]);

  return (
    <div className="progressTimerParent">
      {totalDifferenceInSeconds && secondToPercentageArray && (
        <div className="privateRoutesProgressTimer">
          <p className="mainLabel">{sessionTimerHeading}</p>
          <div className="circularProgressDiv">
            <SessionTimeOutTimer
              interval={interval}
              percentages={secondToPercentageArray}
              totalSeconds={totalDifferenceInSeconds}
              bodyHeight={bodyHeight}
              logOutHandler={logOutHandler}
              contextObj={contextObj}
              sessionExtendCallHandler={sessionExtendCallHandler}
            />
          </div>
        </div>
      )}
    </div>
  );
};
